import { render, staticRenderFns } from "./HeaderUserInfo.vue?vue&type=template&id=67c494e3&scoped=true&"
import script from "./HeaderUserInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserInfo.vue?vue&type=style&index=0&id=67c494e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c494e3",
  null
  
)

export default component.exports